import React from "react";
import { Button as ButtonPR } from 'primereact/button';
import Langs, { Localize } from '../../app/lang/langs';
import { config } from '../../app/utils/config';
import styles from './Permissions.module.css';

export default function PermissionButton({ type, isActive, onClick, useLocalize = false }) {

    const getIcon = () => {
        if (type === config.permissionTypes.view) return "pi pi-eye";
        if (type === config.permissionTypes.remove) return "pi pi-eye-slash";
        if (type === config.permissionTypes.view_all) return "pi pi-globe";
        if (type === config.permissionTypes.edit_all) return "pi pi-globe";
        return "pi pi-pencil";
    };

    const getActiveClass = () => {
        if (!isActive) return "p-button-secondary";
        if (type === config.permissionTypes.view) return "p-button-success";
        if (type === config.permissionTypes.remove) return "p-button-danger";
        if (type === config.permissionTypes.view_all) return "p-button-info";
        if (type === config.permissionTypes.edit_all) return "p-button-help";
        return "p-button-warning";
    };

    const getLabel = () => {
        if (type === config.permissionTypes.view_all) return <Langs str="view_all" />;
        if (type === config.permissionTypes.edit_all) return <Langs str="edit_all" />;
        if (useLocalize) return Localize(type);
        const langKey = type === 'remove' ? 'invisible' : type === 'view' ? 'visible' : type;
        return <Langs str={langKey} />;
    };

    return (
        <ButtonPR
            label={getLabel()}
            icon={getIcon()}
            className={`${styles.permissionBtn} ${getActiveClass()}`}
            onClick={onClick}
        />
    );
}
